import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../common/chart/chartContainer/Line'
import { Legend } from '../../../../../common/chart/legend'
import { Element } from '../../../../../common/html/element'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../helpers/common'
import {
  convertData,
  formatVal,
  valToPercent,
} from '../../../../../helpers/value'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { changeChecked, selectChecked } from '../../store/slice'
import { RATIO_CODE, TREND_DATA } from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const chartId = useRef(getUnique())

  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)
  const {
    formatedUnit,
    multiplier,
    getExchangeRate,
    formatValueWithUnit,
    decimalLength,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
    [RATIO_CODE.INS_GROWTH, RATIO_CODE.REINS_GROWTH, RATIO_CODE.NET_INS_GROWTH],
  )

  const checkboxs = TREND_DATA.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const bars = checkboxs.filter(
    (item) => item.isBarChart && checked.includes(item.value),
  )

  const lines = checkboxs.filter(
    (item) => item.isLineChart && checked.includes(item.value),
  )

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const isNotHasBar = !bars.length

  return (
    <div
      style={{
        height: getStyleHeightContainer(
          isDynamicReport || isDownloadComponent,
          isNoData,
          332,
        ),
      }}
      className={`flexColumn ${classes.profitabilityTrenContainer}`}
    >
      <Element className={classes.pdb6} style={{ color: '#9C9C9C' }}>
        {!isNotHasBar ? formatedUnit : <>&nbsp;</>}
      </Element>
      <div className="dFlex h100">
        <ChartContainer
          chartId={chartId.current}
          data={dataConvert}
          margin={{
            top: 10,
            bottom: 0,
            left:
              isNotHasBar || isDynamicReport || isDownloadComponent ? 16 : 0,
            right: isDynamicReport || isDownloadComponent ? 16 : 0,
          }}
          width={'70%'}
          height={'100%'}
          xAxis={[{ dataKey: 'year', height: 30 }]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: bars.map((item) => item.value),
              isBarChart: true,
              hide: isNotHasBar,
              decimalLength,
            },
            {
              yAxisId: 'right',
              orientation: 'right',
              dataKeys: lines.map((item) => item.value),
              isLineChart: true,
              tickFormatter: (value) => formatVal(value, locale) + '%',
            },
          ]}
          tooltip={{
            schema: {
              content: [
                ...bars.map((bar) => ({
                  dataKey: bar.value,
                  label: bar.title,
                  formatValue: (value) => formatValueWithUnit({ value }),
                })),
                ...lines.map((line) => ({
                  dataKey: line.value,
                  label: line.title,
                  formatValue: (value) => valToPercent(value, locale, true),
                })),
              ],
            },
          }}
        >
          {bars.map((bar) => (
            <Bar
              key={bar.value}
              yAxisId="left"
              dataKey={bar.value}
              fill={bar.color}
              maxBarSize={35}
            />
          ))}
          {lines.map((line) => (
            <Line
              key={line.value}
              yAxisId="right"
              dataKey={line.value}
              stroke={line.color}
            />
          ))}
        </ChartContainer>
        <div className="h100 w30 px1 py1 dFlex alignItemsCenter justifyContentCenter">
          <ScrollComponent>
            <Legend
              chartId={chartId.current}
              items={checkboxs.map((item) => ({
                title: item.title,
                value: item.value,
                dataKey: item.value,
                color: item.color,
                isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
                listCheckBox: checked,
                setListCheckBox: setChecked,
                isI18n: false,
                isDynamicReport: isDynamicReport || isDownloadComponent,
              }))}
              className="flexColumn"
            />
          </ScrollComponent>
        </div>
      </div>
    </div>
  )
}

export default Trend
